import * as React from "react";
function SvgBubbles(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M15 19h2l4 4v-4h2V9M23 9H9v6"
      />
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M17 9V3h14v10h-2v4l-4-4h-2M15 15H1v10h8l4 4v-4h2V15"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBubbles);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
